import React from 'react';
import styled from 'styled-components';
import FormHelperText from '@material-ui/core/FormHelperText';

const RedText = styled(FormHelperText)`
  color: #f44336 !important;
`;

const ErrorText = ({ id, text }) => <RedText id={id}>{text}</RedText>;

export default ErrorText;
